import { formatMessage } from "../helpers/LanguageHelper";

/**
 * Thrown when no objects are found for a given tag at script-build time.
 */
export class MissingObjectsException extends Error {
  public readonly tagLabel: string;
  constructor(tagLabel: string) {
    console.error(`Missing objects for tag: ${tagLabel}`);
    super(formatMessage("cof.validation.message.failed.noobjectsfound"));
    this.tagLabel = tagLabel;
    this.name = "MissingObjectsException";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/**
 * Thrown when a tag referenced by a rule cannot be resolved.
 */
export class MissingTagException extends Error {
  public readonly tagLabel: string;
  constructor(tagLabel: string) {
    console.error(`Missing tag: ${tagLabel}`);
    super(formatMessage("cof.validation.message.failed.notagfound"));
    this.tagLabel = tagLabel;
    this.name = "MissingTagException";
    Object.setPrototypeOf(
      this,

      new.target.prototype
    );
  }
}

/**
 * Thrown when a tag has only a single object, making consistency trivially true.
 * The caller may decide to skip the consistency check or treat the rule as verified.
 */
export class SingleObjectException extends Error {
  constructor(tagLabel: string) {
    console.log(`Tag "${tagLabel}" has only one object — consistency check is trivially true`);
    super(`Tag "${tagLabel}" has only one object — consistency check is trivially true`);
    this.name = "SingleObjectException";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
